import {Article} from '@/model/Article';
import {Firestore} from '@/plugins/Firestore';
import {
    commitCoveringArticle,
    type ArticleSaveIo,
    type GenerationSaveOptions,
    type GenerationSaveResult,
} from '@/service/commitCoveringArticle';
import {CompletionMap, SaveArticleBody} from '@/service/saveIntegrity';

export type {ArticleSaveIo, GenerationSaveOptions, GenerationSaveResult};
export {commitCoveringArticle};

export function liveArticleSaveIo(options: GenerationSaveOptions): ArticleSaveIo {
    return {
        loadCompletions(articleId: string): Promise<CompletionMap> {
            return Firestore.loadArticleCompletions(articleId);
        },
        read(articleId: string): Promise<SaveArticleBody | null> {
            return Firestore.getUserArticle(articleId);
        },
        async write(article: SaveArticleBody): Promise<void> {
            await Firestore.saveUserArticle(article as Article, {
                generationStart: options.generationStart,
                integrityChecked: true,
            });
        },
        async markDone(article: SaveArticleBody): Promise<void> {
            const current = article as Article;
            await Firestore.updateArticleGenerationStatus(current, {
                enhanced: 'done',
                aiGenerateStatus: 'done',
            });
        },
    };
}

export function commitCoveringArticleLive(
    article: Article,
    options: GenerationSaveOptions,
): Promise<GenerationSaveResult> {
    return commitCoveringArticle(article, options, liveArticleSaveIo(options));
}
